export const MEDIA_EVENTS = {
  START: 'start',
  FIRST_QUARTILE: 'firstQuartile',
  MIDPOINT: 'midpoint',
  THIRD_QUARTILE: 'thirdQuartile',
  COMPLETE: 'complete',
} as const;
export type IMediaAnalytics = {
  hasPendingEvents: () => boolean;

  resolveAllPendingEvents: (eventName: string) => {
    questionId: string;
    pendingEvents: PendingEventData | null;
  }[];
};
export interface PendingEventData {
  answerIds: string[];
  [key: string]: unknown;
}
